// 项目/任务状态：int 存储（与后端 ProjectStatus/TaskStatus 枚举一致），前端展示转中文
export const ProjectStatusCode = Object.freeze({
  REVIEW: 0, // 待评审
  APPROVED: 100, // 已立项
  DEVELOPING: 200, // 开发中
  SUBMITTED: 300, // 已提交
  ACCEPTED: 400, // 已验收
  CLOSED: 500, // 已关闭
});

export const TaskStatusCode = Object.freeze({
  TODO: 0, // 未开始
  DOING: 100, // 进行中
  DONE: 200, // 已完成
  CANCEL: 300, // 已取消
});

export const PROJECT_STATUS_OPTIONS = [
  {value: ProjectStatusCode.REVIEW, label: "待评审", tag: "info"},
  {value: ProjectStatusCode.APPROVED, label: "已立项", tag: "primary"},
  {value: ProjectStatusCode.DEVELOPING, label: "开发中", tag: "warning"},
  {value: ProjectStatusCode.SUBMITTED, label: "已提交", tag: "success"},
  {value: ProjectStatusCode.ACCEPTED, label: "已验收", tag: "success"},
  {value: ProjectStatusCode.CLOSED, label: "已关闭", tag: "info"},
];

export const TASK_STATUS_OPTIONS = [
  {value: TaskStatusCode.TODO, label: "未开始", tag: "info"},
  {value: TaskStatusCode.DOING, label: "进行中", tag: "primary"},
  {value: TaskStatusCode.DONE, label: "已完成", tag: "success"},
  {value: TaskStatusCode.CANCEL, label: "已取消", tag: "danger"},
];

function toCode(status) {
  if (status === null || status === undefined || status === "") {
    return null;
  }
  const n = Number(status);
  return Number.isNaN(n) ? null : n;
}

function option(list, status) {
  const code = toCode(status);
  if (code === null) {
    return null;
  }
  return list.find(o => o.value === code) || null;
}

/** 是否存在有效状态（0 也是有效状态，不能用 truthy 判断） */
export function hasStatus(status) {
  return status !== null && status !== undefined && status !== "" && !Number.isNaN(Number(status));
}

export function projectStatusLabel(status) {
  const o = option(PROJECT_STATUS_OPTIONS, status);
  return o ? o.label : null;
}

export function projectStatusTag(status) {
  const o = option(PROJECT_STATUS_OPTIONS, status);
  return o ? o.tag : "info";
}

export function taskStatusLabel(status) {
  const o = option(TASK_STATUS_OPTIONS, status);
  return o ? o.label : null;
}

export function taskStatusTag(status) {
  const o = option(TASK_STATUS_OPTIONS, status);
  return o ? o.tag : "info";
}
